import { push } from 'react-router-redux';
import { mmsStore } from '../app/app.config';
import { paths } from '../app/app.routes';
import { SimpleResponse } from '../app/app.types';
import { SAVE_TOKEN_LAST_USED_TIME } from '../idle/Constants';
import { isAuthTokenExpired } from '../commons/AuthTokenValidator';
import { TOKEN_EXPIRED } from '../idle/Constants';

export const callApi = <B extends {}>(
  url: RequestInfo,
  requireAuthToken: boolean,
  options?: RequestInit,
  isLoginMethod?: boolean
): Promise<SimpleResponse<B>> => {
  if (isAuthTokenExpired() && requireAuthToken) {
    return new Promise((resolve, reject) => {
      mmsStore.dispatch({type: TOKEN_EXPIRED});
    });
  } else {
    return fetch(url, options)
      .then(response => {

        if (response.status === 401) {
          mmsStore.dispatch({type: TOKEN_EXPIRED});
          return {
            statusCode: response.status,
            body: {}
          };
        } else if (response.status === 500) {
          mmsStore.dispatch(push(paths.internalServerError));
          mmsStore.dispatch({type: SAVE_TOKEN_LAST_USED_TIME});
          
          return {
            statusCode: response.status,
            body: {}
          };
        } else if (requireAuthToken || isLoginMethod) {
          mmsStore.dispatch({type: SAVE_TOKEN_LAST_USED_TIME});
        }

        return response.json()
          .then(data => {
            return {
              statusCode: response.status,
              body: data
            };
        });
      });
  }
};


// WEBPACK FOOTER //
// ./src/util/ApiCaller.tsx